import { ContractRunner, ethers } from "ethers";
import { contractABI } from "./abi-asto";
import { alchemy, web3 } from "../web3Config";
import { User } from "@/types";
import { useSmartAccountClient, useSendUserOperation } from "@account-kit/react";
import { SWAP_CONTRACT_URL } from "./swap";
import Big from 'big.js';
export const ASTO_CONTRACT_ADDRESS = "0xAFd24e5B967148a3e83Cc51b20f31ef507315B29"

export function getAstoTokenContract() {
    return new web3.eth.Contract(contractABI, ASTO_CONTRACT_ADDRESS);
}

export function addAllowanceTransaction(amount: string) {
    const astoContract = getAstoTokenContract()
    const data = astoContract.methods.approve(SWAP_CONTRACT_URL, amount).encodeABI();
    const transactionParameters = {
        target: ASTO_CONTRACT_ADDRESS, // Required except during contract publications.
        data: data,
    } as {
        target: `0x${string}`;
        data: `0x${string}`;
    };
    return transactionParameters;
}

export function mintTransaction(amount: string, user: User) {
    const astoContract = getAstoTokenContract()
    const data = astoContract.methods.mint(user.address, amount).encodeABI();
    const transactionParameters = {
        target: ASTO_CONTRACT_ADDRESS, // Required except during contract publications.
        data: data,
    } as {
        target: `0x${string}`;
        data: `0x${string}`;
    };
    return transactionParameters;
}

export async function getAstoDetails(user: User | undefined | null) {
    const astoContract = getAstoTokenContract()
    const tokenName = await astoContract.methods.name().call();
    const symbol = await astoContract.methods.symbol().call();
    const decimals = await astoContract.methods.decimals().call();
    const balance = user && await astoContract.methods.balanceOf(user.address).call();
    const allowanceForSwap = user && await astoContract.methods.allowance(user.address, SWAP_CONTRACT_URL).call();
    const totalSupply = await astoContract.methods.totalSupply().call();
    return {
        tokenName,
        balance: (Number(balance) / 10 ** Number(decimals)),
        decimals,
        symbol,
        allowanceForSwap,
        totalSupply
    };
}
